export default __webpack_public_path__ + "bcd0a05717cedd37f2dc715777e0f848.png";